(()=>{
  'use strict';
  const body=document.body;
  body.classList.add('br-js');
  const commerce=body.dataset.commerce==='true';
  const currency=body.dataset.currency||'USD';
  const one=(selector,root=document)=>root?.querySelector(selector)||null;
  const money=cents=>{
    const amount=Number(cents)/100;
    try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(amount)}
    catch{return amount.toFixed(2)}
  };
  const element=(tag,cls,text)=>{
    const el=document.createElement(tag);
    if(cls)el.className=cls;
    if(text!=null)el.textContent=String(text);
    return el;
  };
  const focusable=root=>[...root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>el.getClientRects().length&&!el.hidden);
  let activeOverlay=null,returnFocus=null,cartBusy=false;
  const currentMenu=()=>one('#br-mobile-menu');
  const currentDrawer=()=>one('[data-br-cart-drawer]');

  const reducedMotion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motionEase='cubic-bezier(.22,1,.36,1)';
  const layerAnimations=new WeakMap();
  let pageLock=null;
  function lockPage(){
    if(pageLock)return;
    pageLock={x:scrollX,y:scrollY,position:body.style.position,top:body.style.top,left:body.style.left,width:body.style.width,overflow:document.documentElement.style.overflow};
    const width=document.documentElement.clientWidth;
    body.classList.add('br-locked');
    body.style.position='fixed';body.style.top=`-${pageLock.y}px`;body.style.left=`-${pageLock.x}px`;body.style.width=`${width}px`;
    document.documentElement.style.overflow='hidden';
  }
  function unlockPage(){
    if(!pageLock)return;
    const saved=pageLock;pageLock=null;body.classList.remove('br-locked');
    Object.assign(body.style,{position:saved.position,top:saved.top,left:saved.left,width:saved.width});
    document.documentElement.style.overflow=saved.overflow;
    window.scrollTo({left:saved.x,top:saved.y,behavior:'instant'});
  }
  function animateLayer(el,property,from,to,duration=320){
    if(!el)return Promise.resolve(true);
    const previous=layerAnimations.get(el),current=previous?getComputedStyle(el)[property]:from;
    if(previous)previous.cancel();
    if(reducedMotion()||!el.animate||!el.isConnected){layerAnimations.delete(el);return Promise.resolve(true)}
    const animation=el.animate([{[property]:current},{[property]:to}],{duration,easing:motionEase,fill:'both'});
    layerAnimations.set(el,animation);
    return animation.finished.then(()=>{if(layerAnimations.get(el)!==animation)return false;layerAnimations.delete(el);animation.cancel();return true}).catch(()=>false);
  }
  function closeOverlay(restore=true){
    const el=activeOverlay;if(!el)return;
    const wasMenu=el.matches('#br-mobile-menu'),focus=returnFocus;
    const backing=one(wasMenu?'[data-br-menu-backdrop]':'[data-br-cart-backdrop]');
    activeOverlay=null;returnFocus=null;el.inert=true;
    if(wasMenu)one('[data-br-menu-toggle]')?.setAttribute('aria-expanded','false');
    if(restore&&focus?.isConnected)focus.focus({preventScroll:true});
    void animateLayer(backing,'opacity','1','0');
    void animateLayer(el,'transform','translateX(0)',wasMenu?'translateX(-100%)':'translateX(100%)').then(finished=>{
      if(!finished||activeOverlay===el)return;
      el.hidden=true;el.inert=false;if(backing)backing.hidden=true;
      if(!activeOverlay&&!one('[data-br-product-zoom-dialog][open]'))unlockPage();
    });
  }
  function reconcileOverlay(){
    if(activeOverlay&&!activeOverlay.isConnected)closeOverlay(false);
  }
  function openOverlay(el,trigger){
    reconcileOverlay();if(!el||activeOverlay===el)return;
    if(activeZoom)disposeProductZoom(activeZoom.dialog);
    closeOverlay(false);returnFocus=trigger||document.activeElement;activeOverlay=el;
    el.hidden=false;el.inert=false;
    const menu=el===currentMenu(),backing=one(menu?'[data-br-menu-backdrop]':'[data-br-cart-backdrop]');
    if(backing){backing.hidden=false;void animateLayer(backing,'opacity','0','1')}
    if(menu)one('[data-br-menu-toggle]')?.setAttribute('aria-expanded','true');
    lockPage();void animateLayer(el,'transform',menu?'translateX(-100%)':'translateX(100%)','translateX(0)');
    (focusable(el)[0]||el).focus({preventScroll:true});
  }
  const accordionStates=new WeakMap();
  function enhanceAccordion(el){
    if(accordionStates.has(el))return;
    accordionStates.set(el,{target:el.open,animation:null});
    el.dataset.brMotion='true';el.dataset.brExpanded=String(el.open);
    // Native exclusivity remains in source for no-JS; JS animates outgoing content before hiding it.
    el.removeAttribute('name');one('summary',el)?.setAttribute('aria-expanded',String(el.open));
  }
  function animateAccordion(el,expand){
    enhanceAccordion(el);const state=accordionStates.get(el),summary=one('summary',el);
    const current=el.getBoundingClientRect().height;
    if(state.animation){state.animation.onfinish=null;state.animation.cancel();state.animation=null}
    state.target=expand;el.dataset.brExpanded=String(expand);summary.setAttribute('aria-expanded',String(expand));
    if(reducedMotion()||!el.animate){el.open=expand;el.style.height='';el.style.overflow='';return}
    el.open=true;el.style.height='auto';
    const css=getComputedStyle(el),border=parseFloat(css.borderTopWidth)+parseFloat(css.borderBottomWidth);
    const target=expand?el.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
    el.style.height=`${current}px`;el.style.overflow='hidden';
    const animation=el.animate([{height:`${current}px`},{height:`${target}px`}],{duration:360,easing:motionEase,fill:'both'});
    state.animation=animation;
    animation.onfinish=()=>{if(state.animation!==animation)return;state.animation=null;el.open=state.target;el.style.height='';el.style.overflow='';animation.cancel()};
  }
  function toggleAccordion(el){
    enhanceAccordion(el);const expand=!accordionStates.get(el).target;
    if(expand)el.closest('[data-br-product]').querySelectorAll('.br-accordion').forEach(other=>{enhanceAccordion(other);if(other!==el&&accordionStates.get(other).target)animateAccordion(other,false)});
    animateAccordion(el,expand);
  }
  let activeZoom=null;
  function disposeProductZoom(dialog){
    const animation=layerAnimations.get(dialog);
    if(animation){layerAnimations.delete(dialog);animation.cancel()}
    if(activeZoom?.dialog===dialog)activeZoom=null;
    if(dialog.open)dialog.close();
    if(!activeOverlay&&!one('[data-br-product-zoom-dialog][open]'))unlockPage();
  }
  function closeProductZoom(dialog){
    const session=activeZoom;
    if(!dialog?.open||!session||session.dialog!==dialog)return;
    void animateLayer(dialog,'opacity','1','0',200).then(done=>{
      if(!done||activeZoom!==session)return;
      activeZoom=null;dialog.close();dialog.classList.remove('is-zoomed');
      if(!activeOverlay&&!one('[data-br-product-zoom-dialog][open]')){
        unlockPage();if(session.trigger?.isConnected)session.trigger.focus({preventScroll:true});
      }
    });
  }
  function openProductZoom(button){
    const dialog=one('[data-br-product-zoom-dialog]'),source=one('img',button);if(!dialog||!source)return;
    if(activeZoom&&activeZoom.dialog!==dialog)disposeProductZoom(activeZoom.dialog);
    closeOverlay(false);
    const session={dialog,trigger:button};activeZoom=session;
    const image=one('[data-br-zoom-image]',dialog),large=button.dataset.brZoomSrc;
    image.src=source.currentSrc||source.src;image.alt=source.alt||button.getAttribute('aria-label')||'Product image';
    dialog.classList.remove('is-zoomed');const toggle=one('[data-br-zoom-size]',dialog);toggle.textContent='Zoom in';toggle.setAttribute('aria-pressed','false');
    if(!dialog.open)dialog.showModal();lockPage();void animateLayer(dialog,'opacity','0','1',240);
    const preload=new Image();preload.src=large;
    preload.decode().then(()=>{if(activeZoom===session&&dialog.open)image.src=large}).catch(()=>{});
  }
  let railDrag=null,suppressRailClick=null;
  document.addEventListener('pointerdown',event=>{
    const rail=event.target.closest?.('[data-br-related-rail]');
    if(!rail||event.pointerType!=='mouse'||event.button!==0||rail.scrollWidth<=rail.clientWidth)return;
    railDrag={rail,id:event.pointerId,x:event.clientX,y:event.clientY,left:rail.scrollLeft,active:false};
  });
  document.addEventListener('pointermove',event=>{
    const drag=railDrag;if(!drag||event.pointerId!==drag.id)return;
    if(!drag.rail.isConnected){railDrag=null;return}
    const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
    if(!drag.active){if(Math.abs(dx)<6||Math.abs(dx)<=Math.abs(dy))return;drag.active=true;drag.rail.classList.add('is-dragging');drag.rail.setPointerCapture(drag.id)}
    event.preventDefault();drag.rail.scrollLeft=drag.left-dx;
  },{passive:false});
  function finishRailDrag(event){
    const drag=railDrag;if(!drag||(event.pointerId!=null&&event.pointerId!==drag.id))return;
    railDrag=null;if(!drag.active)return;
    suppressRailClick={rail:drag.rail,until:performance.now()+400};
    drag.rail.classList.remove('is-dragging');
    if(drag.rail.hasPointerCapture(drag.id))drag.rail.releasePointerCapture(drag.id);
  }
  document.addEventListener('pointerup',finishRailDrag);
  document.addEventListener('pointercancel',finishRailDrag);
  document.addEventListener('lostpointercapture',finishRailDrag);
  window.addEventListener('blur',finishRailDrag);
  document.addEventListener('dragstart',event=>{if(event.target.closest?.('[data-br-related-rail]'))event.preventDefault()});
  document.addEventListener('click',event=>{if(suppressRailClick&&performance.now()<suppressRailClick.until&&suppressRailClick.rail.contains(event.target)){event.preventDefault();event.stopImmediatePropagation();suppressRailClick=null}},true);
  document.addEventListener('cancel',event=>{if(event.target.matches?.('[data-br-product-zoom-dialog]')){event.preventDefault();closeProductZoom(event.target)}},true);
  const cartUrl=()=>currentDrawer()?.dataset.cartUrl||'/cart';
  function cartError(message){
    const status=currentDrawer()?.querySelector('[data-br-cart-status]');
    if(status)status.textContent=message;
  }
  function renderCart(cart){
    const drawer=currentDrawer();
    if(!drawer)return;
    const holder=one('[data-br-cart-content]',drawer),bottom=one('[data-br-cart-bottom]',drawer);
    const continueLink=one('[data-br-cart-continue]',drawer),count=one('[data-br-cart-count]');
    if(!holder||!bottom||!continueLink)return;
    holder.replaceChildren();
    const items=Array.isArray(cart.items)?cart.items:[];
    const quantity=Number(cart.item_count||0);
    if(count){count.hidden=quantity===0;count.textContent=quantity?`(${quantity})`:''}
    if(!items.length){
      holder.append(element('p','br-cart-empty','Your cart is empty'));
      bottom.hidden=true;continueLink.hidden=false;return;
    }
    continueLink.hidden=true;bottom.hidden=false;
    for(const item of items){
      const row=element('article','br-cart-item');
      let productUrl=null;
      try{const url=new URL(item.url,location.origin);if(url.origin===location.origin&&url.pathname.includes('/products/'))productUrl=url.pathname+url.search}catch{}

      if(item.featured_image?.url||item.image){
        const pic=element('img');pic.src=item.featured_image?.url||item.image;
        pic.alt=item.featured_image?.alt||item.product_title||'';
        pic.loading='lazy';
        if(productUrl){const link=element('a','br-cart-image-link');link.href=productUrl;link.setAttribute('aria-label',`View ${item.product_title||item.title||'product'}`);link.append(pic);row.append(link)}else row.append(pic);
      }
      const info=element('div','br-cart-item-info');
      const top=element('div','br-cart-item-top'),heading=element('div');
      const title=element(productUrl?'a':'span',productUrl?'br-cart-product-link':'',item.product_title||item.title||'Product');
      if(productUrl)title.href=productUrl;heading.append(title);
      if(item.variant_title&&item.variant_title!=='Default Title')heading.append(element('small','',item.variant_title));
      top.append(heading,element('span','',money(item.final_line_price??item.line_price??0)));
      info.append(top);
      const actions=element('div','br-cart-item-bottom'),quantityBox=element('div','br-cart-qty');
      const less=element('button','','−'),more=element('button','','+');
      less.type=more.type='button';
      less.setAttribute('aria-label',`Decrease quantity of ${item.product_title||'item'}`);
      more.setAttribute('aria-label',`Increase quantity of ${item.product_title||'item'}`);
      less.dataset.brChange=item.key;more.dataset.brChange=item.key;
      less.dataset.quantity=String(Math.max(0,item.quantity-1));more.dataset.quantity=String(item.quantity+1);
      quantityBox.append(less,element('span','',item.quantity),more);
      const remove=element('button','br-cart-remove','Remove');
      remove.type='button';remove.dataset.brChange=item.key;remove.dataset.quantity='0';
      actions.append(quantityBox,remove);info.append(actions);row.append(info);holder.append(row);
    }
    const subtotal=one('[data-br-cart-subtotal]',drawer);
    if(subtotal)subtotal.textContent=money(cart.items_subtotal_price??cart.total_price??0);
  }
  async function getCart(){
    const drawer=currentDrawer();
    if(!drawer)return;
    if(!commerce){renderCart({items:[],item_count:0});cartError('Coming soon');return}
    try{
      const response=await fetch(`${cartUrl()}.js`,{credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!response.ok)throw Error(`Cart unavailable (${response.status})`);
      renderCart(await response.json());
    }catch(err){
      cartError(err.message);
      const updated=currentDrawer();
      one('[data-br-cart-content]',updated)?.replaceChildren(element('p','','Cart could not load. Use the full cart page.'));
      const bottom=one('[data-br-cart-bottom]',updated);if(bottom)bottom.hidden=true;
    }
  }
  async function changeCart(button){
    if(!commerce||cartBusy||!currentDrawer())return;
    cartBusy=true;button.disabled=true;
    try{
      const response=await fetch(`${currentDrawer().dataset.cartChangeUrl}.js`,{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({id:button.dataset.brChange,quantity:Number(button.dataset.quantity)})
      });
      if(!response.ok)throw Error(`Cart could not update (${response.status})`);
      renderCart(await response.json());cartError('Cart updated');
    }catch(err){cartError(err.message);await getCart()}
    finally{cartBusy=false}
  }
  function variantParts(form){
    const root=form.closest('[data-br-product]');
    return {root,select:one('[data-br-variant]',form),qty:one('[data-br-quantity]',form),price:root&&one('[data-br-price]',root),error:root&&one('[data-br-form-error]',root)};
  }
  function validVariant(form){
    const {select,qty}=variantParts(form),option=select?.selectedOptions[0],quantity=Number(qty?.value);
    return !!(option&&!option.disabled&&/^\d+$/.test(option.value)&&Number.isSafeInteger(quantity)&&quantity>0);
  }
  function syncVariant(form,updateUrl){
    const {select,price}=variantParts(form);if(!select)return;
    const option=select.selectedOptions[0];
    form.querySelectorAll('[data-br-option]').forEach(button=>{
      const position=Number(button.dataset.brOption),value=button.dataset.brValue;
      button.setAttribute('aria-pressed',String(option?.getAttribute(`data-option-${position}`)===value));
      button.disabled=![...select.options].some(candidate=>!candidate.disabled&&candidate.getAttribute(`data-option-${position}`)===value&&Array.from({length:position-1},(_,i)=>i+1).every(i=>candidate.getAttribute(`data-option-${i}`)===option?.getAttribute(`data-option-${i}`)));
    });
    if(option?.dataset.price&&price)price.textContent=money(option.dataset.price);
    if(updateUrl&&option&&!option.disabled){
      const url=new URL(location.href);url.searchParams.set('variant',option.value);
      history.replaceState(history.state,'',url);
    }
  }
  async function addProduct(form,event){
    if(!commerce){event.preventDefault();return} // Preserve the launch gate even on keyboard submission.
    event.preventDefault();
    const {error}=variantParts(form);
    if(!validVariant(form)){
      if(error){error.hidden=false;error.textContent='Choose an available option'}
      return;
    }
    const button=one('[data-br-add]',form);
    if(!button||button.disabled)return;
    button.disabled=true;button.textContent='Adding…';if(error)error.hidden=true;
    try{
      const drawer=currentDrawer();if(!drawer)throw Error('Cart unavailable');
      const response=await fetch(`${drawer.dataset.cartAddUrl}.js`,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!response.ok){const data=await response.json().catch(()=>({}));throw Error(data.description||`Add failed (${response.status})`)}
      await response.json();openOverlay(currentDrawer(),button);await getCart();cartError('Added to cart');
    }catch(err){if(error){error.hidden=false;error.textContent=err.message}}
    finally{if(button.isConnected){button.disabled=false;button.textContent='Add to cart'}}
  }
  function buyNow(form){
    if(!commerce||!validVariant(form))return;
    const {select,qty}=variantParts(form),quantity=Number(qty.value);
    window.location.assign(`${cartUrl().replace(/\/$/,'')}/${select.value}:${quantity}`);
  }
  function updateGallery(gallery){
    const related=gallery.closest('[data-br-related]');
    const progress=related?one('[data-br-related-progress]',related):gallery.closest('[data-br-product]')?.querySelector('[data-br-gallery-progress]');
    if(!progress)return;
    const fraction=gallery.scrollWidth?Math.min(1,(gallery.scrollLeft+gallery.clientWidth)/gallery.scrollWidth):1;
    progress.style.transform=`scaleX(${fraction})`;
  }
  const initializedProducts=new WeakSet();
  function initProduct(root){
    if(initializedProducts.has(root))return;
    initializedProducts.add(root);
    const form=one('[data-br-product-form]',root),select=form&&one('[data-br-variant]',form);
    if(form&&select){
      const requested=new URL(location.href).searchParams.get('variant');
      if(requested){const option=[...select.options].find(item=>item.value===requested&&!item.disabled);if(option)select.value=option.value}
      syncVariant(form,false);
    }
    const gallery=one('[data-br-gallery]',root);if(gallery)updateGallery(gallery);
  }
  let gridObserver=null,observedGrid=null,observedLink=null,loadingNext=false;
  const primedGrids=new WeakSet();
  async function appendNext(link,grid){
    if(loadingNext||!link?.href||!grid.isConnected)return;
    loadingNext=true;
    try{
      const response=await fetch(link.href,{credentials:'same-origin'});
      if(!response.ok)throw Error(`Page ${response.status}`);
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const nextGrid=one('[data-br-product-grid]',html);
      if(!nextGrid||!grid.isConnected||!link.isConnected)throw Error('Product grid missing');
      for(const card of nextGrid.querySelectorAll('.br-card'))grid.append(document.importNode(card,true));
      const next=one('[data-br-next]',html),url=new URL(link.href);
      history.replaceState(history.state,'',url.pathname+url.search);
      if(next)link.href=next.href;else link.remove();
      if(link.isConnected)gridObserver?.observe(link);
    }catch{if(link.isConnected){link.textContent='Load more';link.hidden=false}}
    finally{loadingNext=false}
  }
  function initGrid(){
    const grid=one('[data-br-product-grid]'),next=one('[data-br-next]');
    if(grid!==observedGrid||next!==observedLink){
      gridObserver?.disconnect();gridObserver=null;observedGrid=grid;observedLink=next;
      if(grid&&next&&'IntersectionObserver'in window){
        gridObserver=new IntersectionObserver(entries=>{
          for(const entry of entries)if(entry.isIntersecting){gridObserver.unobserve(entry.target);appendNext(entry.target,grid)}
        },{rootMargin:'350px'});
        gridObserver.observe(next);
      }
    }
    if(grid&&!primedGrids.has(grid)&&new URL(location.href).searchParams.get('page')==='2'){
      primedGrids.add(grid);
      const first=new URL(location.href);first.searchParams.delete('page');
      fetch(first.pathname+first.search,{credentials:'same-origin'}).then(response=>{
        if(!response.ok)throw Error('Previous page unavailable');return response.text();
      }).then(text=>{
        const previous=one('[data-br-product-grid]',new DOMParser().parseFromString(text,'text/html'));
        if(grid.isConnected&&previous)for(const card of [...previous.querySelectorAll('.br-card')].reverse())grid.prepend(document.importNode(card,true));
      }).catch(()=>{/* Native page 2 remains accessible. */});
    }
  }
  function initialize(){
    reconcileOverlay();
    document.querySelectorAll('[data-br-product] .br-accordion').forEach(enhanceAccordion);
    document.querySelectorAll('[data-br-product]').forEach(initProduct);
    document.querySelectorAll('[data-br-related-rail]').forEach(updateGallery);
    initGrid();
  }
  document.addEventListener('click',event=>{
    const target=event.target;if(!(target instanceof Element))return;
    const match=selector=>target.closest(selector);
    const accordion=match('[data-br-product] .br-accordion > summary');
    if(accordion){event.preventDefault();toggleAccordion(accordion.parentElement);return}
    const zoom=match('[data-br-product-zoom]');if(zoom&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey){event.preventDefault();openProductZoom(zoom);return}
    const zoomDialog=match('[data-br-product-zoom-dialog]');
    if(zoomDialog){
      if(match('[data-br-product-zoom-close]')||target===zoomDialog){closeProductZoom(zoomDialog);return}
      if(match('[data-br-zoom-size]')){const zoomed=zoomDialog.classList.toggle('is-zoomed');target.setAttribute('aria-pressed',String(zoomed));target.textContent=zoomed?'Zoom out':'Zoom in';one('.br-product-zoom-canvas',zoomDialog).scrollTo({left:0,top:0,behavior:'instant'});return}
    }
    let button=match('[data-br-menu-toggle]');
    if(button){const menu=currentMenu();if(activeOverlay===menu)closeOverlay();else openOverlay(menu,button);return}
    button=match('[data-br-cart-open]');
    if(button){openOverlay(currentDrawer(),button);void getCart();return}
    if(match('[data-br-menu-close],[data-br-cart-close],[data-br-menu-backdrop],[data-br-cart-backdrop]')){closeOverlay();return}
    if(match('#br-mobile-menu a')){closeOverlay(false);return}
    button=match('[data-br-search-toggle]');
    if(button){const widget=button.closest('[data-br-search]'),form=one('form',widget);
      if(form){form.hidden=false;button.hidden=true;button.setAttribute('aria-expanded','true');one('input[name=q]',form)?.focus()}
      return;
    }
    button=match('[data-br-notice-dismiss]');if(button){button.closest('[data-br-announcement]').hidden=true;return}
    button=match('[data-br-change]');if(button&&currentDrawer()?.contains(button)){void changeCart(button);return}
    button=match('[data-br-cart-page-step]');
    if(button){
      const input=one('input[name="updates[]"]',button.closest('[data-br-cart-page-quantity]'));
      if(input){
        if(!Number.isFinite(input.valueAsNumber))input.value='0';
        if(button.dataset.brCartPageStep==='1')input.stepUp();else input.stepDown();
        if(input.valueAsNumber<0)input.value='0';
        input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      return;
    }
    button=match('[data-br-option]');
    if(button&&!button.disabled){const form=button.closest('[data-br-product-form]'),select=form&&one('[data-br-variant]',form);
      if(select){
        const current=select.selectedOptions[0],position=Number(button.dataset.brOption);
        const candidates=[...select.options].filter(option=>!option.disabled&&option.getAttribute(`data-option-${position}`)===button.dataset.brValue&&Array.from({length:position-1},(_,i)=>i+1).every(i=>option.getAttribute(`data-option-${i}`)===current?.getAttribute(`data-option-${i}`)));
        const exact=candidates.find(option=>[1,2,3].every(i=>i===position||option.getAttribute(`data-option-${i}`)===current?.getAttribute(`data-option-${i}`)));
        const selected=exact||candidates[0];
        if(selected){select.value=selected.value;syncVariant(form,true);select.dispatchEvent(new Event('input',{bubbles:true}))}
      }
      return;
    }
    button=match('[data-br-size-unit]');
    if(button){
      const chart=button.closest('[data-br-size-chart]'),unit=button.dataset.brSizeUnit;
      chart.querySelectorAll('[data-br-size-unit]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      chart.querySelectorAll('[data-br-unit]').forEach(item=>{item.textContent=item.dataset[unit]});
      const label=one('[data-br-unit-label]',chart);if(label)label.textContent=unit==='cm'?'Centimeters':'Inches';
      return;
    }
    button=match('[data-br-buy-now]');
    if(button&&!button.disabled){const form=button.closest('[data-br-product-form]');if(form)buyNow(form)}
  });
  window.addEventListener('submit',event=>{
    const form=event.target.closest?.('[data-br-product-form]');
    if(!form)return;
    // This form is AJAX-owned: let Shopify observe the successful cart request,
    // not an additional speculative native-form submission before it succeeds.
    event.stopPropagation();
    void addProduct(form,event);
  },true);
  document.addEventListener('change',event=>{
    if(event.target.matches?.('[data-br-variant]'))syncVariant(event.target.closest('[data-br-product-form]'),true);
  });
  document.addEventListener('scroll',event=>{
    if(event.target.matches?.('[data-br-gallery],[data-br-related-rail]'))updateGallery(event.target);
  },true);
  document.addEventListener('keydown',event=>{
    reconcileOverlay();
    if(event.key==='Escape'){
      const widget=document.activeElement?.closest?.('[data-br-search]');
      if(widget){const form=one('form',widget),trigger=one('[data-br-search-toggle]',widget);
        if(form&&!form.hidden){form.hidden=true;trigger.hidden=false;trigger.setAttribute('aria-expanded','false');trigger.focus();event.preventDefault();return}
      }
      if(activeOverlay){event.preventDefault();closeOverlay()}
    }
    if(event.key==='Tab'&&activeOverlay){
      const elements=focusable(activeOverlay);if(!elements.length)return;
      const first=elements[0],last=elements.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
    }
    const gallery=event.target.closest?.('[data-br-gallery],[data-br-related-rail]');
    if(gallery&&(event.key==='ArrowLeft'||event.key==='ArrowRight')){
      event.preventDefault();gallery.scrollBy({left:(event.key==='ArrowRight'?1:-1)*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
  });
  window.addEventListener('resize',()=>{
    if(pageLock)body.style.width=`${document.documentElement.clientWidth}px`;
    document.querySelectorAll('[data-br-related-rail]').forEach(updateGallery);
  });
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('toggle',event=>{
    const opened=event.target;
    if(!opened.matches?.('[data-br-product] .br-accordion')||!opened.open||accordionStates.has(opened))return;
    opened.closest('[data-br-product]').querySelectorAll('.br-accordion[open]').forEach(other=>{if(other!==opened)other.open=false});
  },true);
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll?.('.br-accordion').forEach(el=>accordionStates.get(el)?.animation?.cancel());
    event.target.querySelectorAll?.('[data-br-product-zoom-dialog]').forEach(disposeProductZoom);
    if(railDrag&&event.target.contains?.(railDrag.rail))finishRailDrag({pointerId:railDrag.id});
    if(activeOverlay&&event.target.contains?.(activeOverlay))closeOverlay(false);
    if(observedGrid&&event.target.contains?.(observedGrid)){gridObserver?.disconnect();gridObserver=null;observedGrid=null;observedLink=null}
  });
  window.addEventListener('popstate',()=>{
    document.querySelectorAll('[data-br-product-form]').forEach(form=>{
      const select=one('[data-br-variant]',form),requested=new URL(location.href).searchParams.get('variant');
      if(select&&requested){const option=[...select.options].find(item=>item.value===requested&&!item.disabled);if(option)select.value=option.value}
      syncVariant(form,false);
    });
  });
  initialize();
})();
